<!-- Camera -->
<div class="camera-bar" gaCategory="Engine 3D Controls" data-test="cameraBar">
  <app-pillbox
    eventCategory="Engine 3D Controls"
    orientation="vertical"
    *ngIf="showNav">
    <ul 
      class="camera-bar__nav"
      aria-label="Camera Control Buttons"
      >
      <!-- Zoom Out -->
      
      <li>
        <button 
          gaEvent
          gaAction="Clicked Zoom Out"
          app-pin-button
          *ngIf="showZoom"
          buttonType="ghost"
          icon="minus"
          tabIndex="0"
          data-test="cameraZoomOut"
          (touchend)="setZoomFixed('out')"
          (mouseup)="setZoomFixed('out')"
          (keyup.enter)="setZoomFixed('out')"
          matTooltip="Zoom Out"
          matTooltipPosition="left">
        </button>
      </li>

      <!-- Zoom In -->
      <li>
        <button 
          gaEvent
          gaAction="Clicked Zoom In"
          app-pin-button
          *ngIf="showZoom"
          buttonType="ghost"
          icon="plus"
          tabIndex="0"
          data-test="cameraZoomIn"
          (touchend)="setZoomFixed('in')"
          (mouseup)="setZoomFixed('in')"
          (keyup.enter)="setZoomFixed('in')"
          matTooltip="Zoom In"
          matTooltipPosition="left">
        </button>
      </li>

      <!-- Return to chapter position -->
      <li>
        <button 
          gaEvent
          gaAction="Clicked Recenter 3D Model"
          app-pin-button
          *ngIf="showResetPosition"
          icon="location"
          buttonType="ghost"
          tabIndex="0"
          (click)="returnToChapterCamera()"
          matTooltip="Recenter 3D model"
          matTooltipPosition="left"
          data-test="cameraReset">
        <label class='visually-hidden'>Clicking this button will reset the camera viewing the 3D model</label>
        </button>
        
      </li>

      <!-- Pan Mode -->
      <li>
        <button 
          gaEvent
          gaAction="Clicked Switch Mode"
          [gaLabel]="(panMode$ | async) === 'pan' ? 'Rotate' : 'Pan'"
          app-pin-button
          [selected]="(panMode$ | async) === 'pan'"
          tabIndex="0"
          *ngIf="showPan"
          icon="arrows-alt"
          buttonType="ghost"
          (click)="togglePan()"
          [matTooltip]="(panMode$ | async) === 'pan' ? 'Switch to Rotate Mode' : 'Switch to Pan Mode'"
          [attr.aria-pressed]="(panMode$ | async) === 'pan'"
          matTooltipPosition="left"
          data-test="cameraPan">
          <span class='visually-hidden'>Clicking this button changes whether the mouse movement rotates or pans the camera</span>
        </button>
        
      </li>
    </ul>
  </app-pillbox>  
</div>